
import { CoercableComponent, StyleValue, Visibility } from "features/feature";
import { getNotifyStyle } from "game/notifications";
import { computeComponent, processedPropType, unwrapRef } from "util/vue";
import { computed, defineComponent, toRefs, unref } from "vue";

export default defineComponent({
    props: {
        visibility: {
            type: processedPropType<Visibility>(Number),
            required: true
        },
        display: {
            type: processedPropType<CoercableComponent>(Object, String, Function),
            required: true
        },
        style: processedPropType<StyleValue>(String, Object, Array),
        classes: processedPropType<Record<string, boolean>>(Object),
        glowColor: processedPropType<string>(String),
        active: Boolean,
        floating: Boolean
    },
    emits: ["selectTab"],
    setup(props, { emit }) {
        const { display, glowColor, floating } = toRefs(props);

        const component = computeComponent(display);

        const glowColorStyle = computed(() => {
            const color = unwrapRef(glowColor);
            if (!color) {
                return {};
            }
            if (unref(floating)) {
                return getNotifyStyle(color);
            }
            return { boxShadow: `0px 9px 5px -6px ${color}` };
        });

        function selectTab() {
            emit("selectTab");
        }

        return {
            selectTab,
            component,
            glowColorStyle,
            unref,
            Visibility
        };
    }
});
